import { getAmountDue } from '@hopdrive/sdk-ar';
import { getAmountDueExecutor } from './amountDueExecutor';

/**
 * What Pay Now charges on an invoice billed through AR charges: sdk-ar's
 * answer for every active charge on it, capped at the amount due the dealer
 * was shown. applyPayment computes the same answer from the same charges when
 * the payment is taken, so the summary and the charge agree. The card fee is
 * added on top by `gatewayChargeTotal` once a payment method is chosen. The
 * reads skip Apollo's cache (see amountDueExecutor), so a large invoice's
 * answers don't make Apollo re-read every watched query.
 */
export async function getPayNowAmount(archargeIds: ReadonlyArray<number>, due: number): Promise<number> {
  const answer = await getAmountDue({ archargeIds, requestedAmount: due }, { executor: getAmountDueExecutor() });
  return answer.amountToCharge;
}
